
import { GroupGoToHelper } from "@/lib/utility/group.go-to-helper";
import { IGroup } from "@/models/group.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IRefDetail } from "./RefsList.vue";
import LatestEntriesCardEmpty from "../cards/LatestEntriesCardEmpty.vue";

@Component({
  components: { LatestEntriesCardEmpty },
  filters: {}
})
export default class RefsGroup extends mixins(Vue) implements IRefDetail<IGroup> {
  @Prop()
  item!: IGroup;

  @Prop()
  itemAsync!: Promise<IGroup>;

  @Prop()
  small!: boolean;

  @Prop()
  confirmable!: boolean;

  isLoading = false;

  group: IGroup | null = null;

  hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }

  hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  emitOpenDetail() {
    this.$emit("openDetail", this.item);
  }

  async beforeMount() {
    this.isLoading = true;

    if (this.item) {
      this.group = this.item;
    } else if (this.itemAsync) {
      try {
        this.group = await this.itemAsync;
      } catch (e) {
        this.$log.error(e);
      }
    }
    this.isLoading = false;
  }

  async goToDetail() {
    if (!this.group) return;
    const partnerId = this.group.partnerId;
    const groupId = this.group.id;
    const newTab = true;

    new GroupGoToHelper(this.$router).goToGroupTypeDetail({
      groupId,
      type: this.group.type,
      partnerId,
      newTab
    });
  }
}
